import {cn} from 'platform/shared-tw';

import {baseFill, baseStroke, createKeyDownHandler} from '../shared/partVariants';

const FLOOR_TOP_OFFSET = 26;
const FLOOR_LEFT_OFFSET = 10;

interface FloorProps {
  onClick?: () => void;
}

export function Floor(props: FloorProps) {
  return (
    <svg
      width="384"
      height="450"
      viewBox="0 0 384 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        'absolute focus:outline-none focus-visible:outline-none',
        props.onClick && 'cursor-pointer group'
      )}
      style={{top: FLOOR_TOP_OFFSET, left: FLOOR_LEFT_OFFSET}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
    >
      <path
        d="M334 449L111 444C94.1149 440.122 33.2801 385.083 21 357C8.26835 327.884 14.2294 272.03 6 257C6 257 0.999897 245.811 1 239L1 225L1 211C0.999897 204.189 6 193 6 193C14.2294 177.97 8.26835 122.116 21 93.0002C33.2801 64.9167 94.1149 9.87823 111 6.00009L334 1.00012C344 1 367.6 4.00012 382 20.0001C370.667 41.6668 348 107.2 348 192L348 225V258C348 342.8 370.667 408.333 382 430C367.6 446 344 449 334 449Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M334 449L111 444C94.1149 440.122 33.2801 385.083 21 357C8.26835 327.884 14.2294 272.03 6 257C6 257 0.999897 245.811 1 239L1 225L1 211C0.999897 204.189 6 193 6 193C14.2294 177.97 8.26835 122.116 21 93.0002C33.2801 64.9167 94.1149 9.87823 111 6.00009L334 1.00012C344 1 367.6 4.00012 382 20.0001C370.667 41.6668 348 107.2 348 192L348 225V258C348 342.8 370.667 408.333 382 430C367.6 446 344 449 334 449Z"
        stroke="currentColor"
        className={baseStroke()}
        strokeWidth="2"
      />
    </svg>
  );
}
